import { useState } from "react";
import { Box, Stack, TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import regex from "../../utils/regex";
import { StepHeader, StepMessage, TextButton, submitButtonSx } from "./common";

// Shown to users registered before mobile numbers were required
export default function AddMobileStep({
  phoneNumber,
  onPhoneNumberChange,
  onSubmit,
  onBack,
  isSubmitting,
  error,
}) {
  const [isTouched, setIsTouched] = useState(false);
  const isValid = regex.mobileNumber.test(phoneNumber);
  const showFieldError = isTouched && !isValid;

  function handleChange(event) {
    // Digits only and max 10, so spaces/extra digits can't be entered (also when pasted)
    onPhoneNumberChange(event.target.value.replace(/\D/g, "").slice(0, 10));
  }

  function handleSubmit(event) {
    event.preventDefault();
    setIsTouched(true);
    if (isValid) onSubmit();
  }

  return (
    <Box component="form" noValidate onSubmit={handleSubmit}>
      <StepHeader title="Add your mobile">
        For your security we now send a code by SMS each time you sign in. Add your
        mobile number to continue.
      </StepHeader>

      <TextField
        fullWidth
        autoFocus
        required
        type="tel"
        name="phoneNumber"
        label="Mobile number"
        autoComplete="tel-national"
        value={phoneNumber}
        onChange={handleChange}
        onBlur={() => phoneNumber && setIsTouched(true)}
        error={showFieldError}
        // A blank helper keeps the layout still when the error appears
        helperText={showFieldError ? "Enter a valid Australian mobile number, e.g. 0412345678." : " "}
        inputProps={{ inputMode: "numeric" }}
      />

      <StepMessage error={error} />

      <LoadingButton
        fullWidth
        type="submit"
        variant="contained"
        loading={isSubmitting}
        sx={{ ...submitButtonSx, mt: 2 }}
      >
        Send code
      </LoadingButton>

      <Stack alignItems="center" sx={{ mt: 3 }}>
        <TextButton onClick={onBack}>Back to sign in</TextButton>
      </Stack>
    </Box>
  );
}
